(()=>{

 	
	let openedModalsCount = 0,
	mainNav = document.querySelector('.mainNav');

	[].forEach.call(document.querySelectorAll('.inner .modal'), ( modal ) =>{
		let wrapper = modal.querySelector('.modal>.modal-wrapper');

		modal.wrapper = wrapper;

		document.body.appendChild( wrapper );
	});



	[].forEach.call(document.querySelectorAll('.modal'), ( modal )=>{
		
		let 
		openButtons = [],
		openButtonsIds = [],
		wrapper = modal.wrapper ? modal.wrapper:modal.querySelector('.modal>.modal-wrapper'),
		content = wrapper.querySelector('.modal-wrapper>.modal-content'),
		closebtn = content.querySelector('.modal-content>.modal-close'),

		overlay = wrapper.querySelector('.modal-wrapper>.modal-overlay');
	
		if(wrapper.dataset.triggerselectors){
			openButtonsSelectors = wrapper.dataset.triggerselectors.split(',');

			openButtonsSelectors.forEach(( selector )=>{

				let elements = document.querySelectorAll( selector );

				for (let i = 0; i < elements.length; ++i) {
				  openButtons.push(elements[i]);
				}

			});
			

		}else {
			openButtons.push(modal.querySelector('.modal>button'));
		}



		openButtons.forEach(
			 ( openButton ) => {

			 	if (openButton) {
					openButton.addEventListener('click', (e)=>{
						let scrollBarWidth = (window.innerWidth - document.documentElement.clientWidth);
						e.stopPropagation();
						e.preventDefault();
						//mainNav.style.paddingRight = (scrollBarWidth)+'px';
						//document.body.style.paddingRight = scrollBarWidth + 'px';
						wrapper.classList.add('modal-wrapper_visuallyHidden');

						setTimeout(
							()=>{
								wrapper.classList.add('modal-wrapper_modalOpen');
							},
							20
						);

						document.body.classList.add('modalOpen');
						openedModalsCount++;
					});
				}
			}
		);


		overlay.addEventListener('click', close);
		closebtn.addEventListener('click', close);

		function close (event) {
			
			
			wrapper.classList.remove('modal-wrapper_modalOpen');
			setTimeout(
				()=>{
					wrapper.classList.remove('modal-wrapper_visuallyHidden');
					openedModalsCount--;
					//unlockBody();
				},
				250
			);
			

		}

		function unlockBody(){
			if( openedModalsCount == 0 ) {
				mainNav.style.paddingRight = '0px';
				document.body.style.paddingRight = '0px';
				wrapper.classList.remove('modal-wrapper_modalOpen');
				document.body.classList.remove('modalOpen');
			}
		}

	});
})();